module.exports = __webpack_public_path__ + "img/logo-2.219644d0.png";